export function startExpiryChecker(expiryTime, onExpired) {
  if (!expiryTime) return null;

  try {
    const expiryDate = new Date(expiryTime);
    if (isNaN(expiryDate.getTime())) throw new Error("Invalid date");

    const now = new Date();
    if (expiryDate <= now) {
      onExpired();
      return null;
    }

    const msLeft = expiryDate - now;
    if (msLeft > 2147483647) {
      console.warn("Expiry too far — no timer set");
      return null;
    }

    const id = setTimeout(() => {
      console.log("Session expired");
      onExpired();
    }, msLeft);

    return id;
  } catch (err) {
    console.error("Expiry checker failed:", err);
    return null;
  }
}

export function clearExpiryChecker(id) {
  if (id) clearTimeout(id);
}